import { isAdCard, type FeedItem } from '@/api/types';

/**
 * Карта, которую надо отметить seen «при показе» — та, на которую юзер только что
 * встал (items[shownIndex]). Засчитываем при показе, а не при уходе: иначе последнюю
 * карту ленты покинуть нельзя (Embla некуда листать) → она не засчитывается, лимит
 * замирает на (limit−1) и экран лимита недостижим. Рекламу не засчитываем; рассинхрон
 * индекса → null.
 */
export function cardShownOnView(items: FeedItem[], shownIndex: number): FeedItem | null {
  const card = items[shownIndex];
  if (!card || isAdCard(card)) return null;
  return card;
}
